module.exports = __webpack_public_path__ + "img/PictureSummary-UNGap-min.2cb01d18.png";